import { FunctionComponent } from 'preact';

const BuyingOptionsTableHead: FunctionComponent<BuyingOptionsTableHeadProps> = ({
    sizeOptions
}) => {;

    return (
        <>
            <thead>
                <tr>
                    <th class="buying-options__table-head-cell">Colour</th>
                    {sizeOptions.map(option => (
                        <th>{option.toUpperCase()}</th>
                    ))}
                </tr>
            </thead>
        </>
    );
};

interface BuyingOptionsTableHeadProps {
    sizeOptions: Array<string>;
}

export default BuyingOptionsTableHead;
